import React, { Fragment } from "react";
import { Paper, withStyles, AppBar, Tabs, Tab, Modal } from '@material-ui/core';
import { Container, Row, Col, Button, Form } from 'react-bootstrap';
import Environment from '../../environment/environment';
import _ from 'lodash';
import OrdenaConvidados from '../../widgets/organizador/ordena-convidados';
import MaterialTable from 'material-table';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';
import GetAppOutlinedIcon from '@material-ui/icons/GetAppOutlined';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';
import autoBind from 'react-autobind';
import ReactSwitch from '../../widgets/_componentes/ReactSwitch';
import { alteraPublicacaoSessao, organizadorSessoesEncerradasPopupInfoQuery, organizadorRelatorioParticipacaoQuery } from '../../graphql/Sessao';
import { gravacaoVideosQuery, gravacaoVideoExclusao, gravacaoVideoAlteraPublicado } from '../../graphql/Gravacao';
import Swal from 'sweetalert2';
import { Query, withApollo } from "react-apollo";
import environment from '../../environment/environment';
import CircularProgress from '@material-ui/core/CircularProgress';
import AddBoxOutlinedIcon from '@material-ui/icons/AddBoxOutlined';
import GravacaoNovoVideoModal from './popup/gravacao-novo-video';
import {
    MuiPickersUtilsProvider,
    KeyboardDateTimePicker,
} from '@material-ui/pickers';
import Input from '@material-ui/core/Input';
import brLocale from "date-fns/locale/pt-BR";
import DateFnsUtils from '@date-io/date-fns';
import VideoPlayerPopup from '../videoPlayer/videoPlayerPopup';
import moment from 'moment';
import {papelListQuery} from "../../graphql/Outros";
const { Control, Group, Label } = Form;



const styles = theme => ({
    button: {
        margin: theme.spacing(1),
    },
    extendedIcon: {
        marginRight: theme.spacing(1),
    },
    root: {
        padding: theme.spacing(3, 2),
        minWidth: '1000px'
    },
    tabRoot: {
        padding: '15px',
    },
    botaoFecharWrapper: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: '20px'
    },
    modalListLine: {
        marginBottom: '2em',
        '&:first-child': {
            paddingTop: '20px'
        }
    },
    modalListLineTitle: {
        fontWeight: 'bold',
        fontSize: '14px'
    },
    modalListLineData: {
        fontSize: '14px'
    },
    modalListLineDataLine: {
        marginBottom: '1em'
    },
    modalListLineDataTitle: {
        fontWeight: '600',
        fontSize: '14px',
        color: '#666'
    },
    spinnerWrapper: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    spinnerText: {
        marginRight: '20px'
    },
    spinner: {
        width: '60px'
    },
    modalWrapper: {
        display: 'flex',
        justifyContent: 'center'
    },
    gravacoesTableWrapper: {
        marginBottom: '10px'
    }
});

class OrgEncerradasPopupDetalhes extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            sessaoId: props.session,
            clickedTtabIndex: 0,
            showModalNovoVideo: false,
            gravacaoSelecionada: null,
            videosMaterialTableQueryFeretch: null,
            displayModalVideoPlayer: false,
            modalVideoUrl: null
        }

        autoBind(this);
    }

    handleChangeTab(event, newValue) {
        this.setState({
            clickedTtabIndex: newValue
        });
    }

    handlePublicadaSwitchChange(gravacaoId, publicadaChecked) {
        const { client } = this.props;
        const checked = publicadaChecked ? 1 : 0;

        client.mutate({
            mutation: alteraPublicacaoSessao,
            variables: {
                id: gravacaoId,
                publicada: checked
            }
        }).then(data => {
            Swal.fire({
                title: "Gravação alterada!",
                text: "Gravação alterada com sucesso",
                icon: "success",
                confirmButtonColor: "#5d5d5d",
                showCancelButton: false,
            });
        }).catch(ex => {
            const errorMessage = ex.graphQLErrors.map(e => e.debugMessage).join("\n");
            Swal.fire({
                title: "Erro ao alterar gravação",
                text: errorMessage || "",
                icon: "error",
                confirmButtonColor: "#ff0000",
                showCancelButton: false,
            });
        });
    }

    renderTabGeral(sessao) {
        const { classes } = this.props;
        const lengthColumnTitle = 3;
        const lengthColumnInfo = 9;

        const prepareHtml = () => {
            return {__html: sessao.texto_convite};
        }

        return (
            <Fragment>
                <Row className={classes.modalListLine}>
                    <Col className={classes.modalListLineTitle} md={lengthColumnTitle}>1. Início Previsto</Col>
                    <Col className={classes.modalListLineData} md={lengthColumnInfo}>{Environment.momentToLocalDateAndTimeString(sessao.inicio)}</Col>
                </Row>
                <Row className={classes.modalListLine}>
                    <Col className={classes.modalListLineTitle} md={lengthColumnTitle}>2. Término Previsto</Col>
                    <Col className={classes.modalListLineData} md={lengthColumnInfo}>{Environment.momentToLocalDateAndTimeString(sessao.fim)}</Col>
                </Row>
                <Row className={classes.modalListLine}>
                    <Col className={classes.modalListLineTitle} md={lengthColumnTitle}>3. Nome da Sessão</Col>
                    <Col className={classes.modalListLineData} md={lengthColumnInfo}>{sessao.nome}</Col>
                </Row>
                <Row className={classes.modalListLine}>
                    <Col className={classes.modalListLineTitle} md={lengthColumnTitle}>4. Gravar Sessão</Col>
                    <Col className={classes.modalListLineData} md={lengthColumnInfo}>{sessao.gravar ? 'Sim' : 'Não'}</Col>
                </Row>
                <Row className={classes.modalListLine}>
                    <Col className={classes.modalListLineTitle} md={lengthColumnTitle}>5. Texto do e-mail de convite</Col>
                    <Col className={classes.modalListLineData} md={lengthColumnInfo}>
                        <div dangerouslySetInnerHTML={prepareHtml()}></div>
                    </Col>
                </Row>
                <Row className={classes.modalListLine}>
                    <Col className={classes.modalListLineTitle} md={lengthColumnTitle}>6. Convidados</Col>
                    <Col className={classes.modalListLineData} md={lengthColumnInfo}>
                        {this.renderListaConvidados(sessao)}
                    </Col>
                </Row>
                {this.renderDadosAvancado(sessao)}
            </Fragment>
        );
    }

    renderListaConvidados(sessao) {
        const { classes } = this.props;

        const lengthColumnTitle = 5
        const lengthColumnInfo = 7
        const apenasUsuarios = OrdenaConvidados(sessao.convidados.filter(el => el.usuario));
        const renderUsuariosConvidados = apenasUsuarios.map((el) => {
            return (
                <Row key={_.uniqueId()} className={classes.modalListLineDataLine}>
                    <Col md={lengthColumnTitle}>{el.usuario.nome}</Col>
                    <Col md={lengthColumnInfo}>{el.papel.nome}</Col>
                </Row>
            );
        });
        return renderUsuariosConvidados;
    }

    renderDadosAvancado(sessao) {
        const { classes } = this.props;

        const lengthColumnTitle = 3;
        const lengthColumnInfo = 9;
        const grupos = OrdenaConvidados(sessao.convidados.filter(el => el.grupo));

        if (grupos.length == 0 && (!sessao.maximo_participantes)) return;

        return (
            <Fragment>
                <Row className={classes.modalListLine}>
                    <Col className={classes.modalListLineTitle} md={lengthColumnTitle}>7. Avançado</Col>
                </Row>
                <Row className={classes.modalListLine}>
                    <Col className={classes.modalListLineData} md={{ span: lengthColumnInfo, offset: lengthColumnTitle }}>

                        <Row className={classes.modalListLineDataLine}>
                            <Col md={lengthColumnTitle} className={classes.modalListLineDataTitle}>Numero máximo de participantes</Col>
                            <Col md={lengthColumnInfo}>{sessao.maximo_participantes}</Col>
                        </Row>
                        <Row className={classes.modalListLineDataLine}>
                            <Col md={lengthColumnTitle} className={classes.modalListLineDataTitle}>Grupos</Col>
                            <Col md={lengthColumnInfo}>
                                {
                                    grupos.map((el) => {
                                        return (
                                            <Row key={_.uniqueId()} className={classes.modalListLineDataLine}>
                                                <Col>{el.grupo.nome}</Col>
                                                <Col>{el.papel.nome}</Col>
                                            </Row>
                                        );
                                    })
                                }
                            </Col>
                        </Row>

                    </Col>
                </Row>
            </Fragment>
        );
    }

    renderTabRelatorioParticipacao(sessao) {
        const { classes } = this.props;

        const participacoes = sessao.participacoes;

        let primeiraEntradaISO, ultimaSaidaISO;

        const getNomeParticipante = (participacao) => {
            let nome = null;
            let usuario = participacao.usuario;

            if(usuario) {
                nome = usuario.nome;

                if(usuario.identificador.indexOf('LDAP;') == 0) {
                    nome += ' ( '+usuario.email.split('@')[0]+' )';
                } else if(usuario.identificador.indexOf('LOCAL::') == 0) {
                    nome += ' ( '+usuario.email +' )';
                }
            } else {
                nome = (participacao.visitante.email || participacao.visitante.nome) + " ( visitante )";
            }

            return nome;
        }

        let participacoesConsolidado = {};
        participacoes.forEach(participacao => {
            const chave = getNomeParticipante(participacao);

            const participacaoEntradaISO = moment(participacao.entrada.replace(" ", "T")+"Z").toISOString();
            if(!primeiraEntradaISO || participacaoEntradaISO < primeiraEntradaISO) {
                primeiraEntradaISO = participacaoEntradaISO;
            }

            const participacaoSaidaISO = moment(participacao.saida.replace(" ", "T")+"Z").toISOString();
            if(!ultimaSaidaISO || participacaoSaidaISO > ultimaSaidaISO) {
                ultimaSaidaISO = participacaoSaidaISO;
            }

            if (!participacoesConsolidado[chave]) {
                participacoesConsolidado[chave] = JSON.parse(JSON.stringify(participacao));
            } else {
                participacoesConsolidado[chave].tempo_total_segundos += participacao.tempo_total_segundos;
            }
            participacoesConsolidado[chave].chave = chave;
        });
        participacoesConsolidado = Object.values(participacoesConsolidado);

        participacoesConsolidado.sort(function(a, b){
            if(a.chave < b.chave) { return -1; }
            if(a.chave > b.chave) { return 1; }
            return 0;
        })

        return (
            <Fragment>
                { (!this.state.relatorioDetalhado) ? <Fragment>
                    <Row className={classes.modalListLine}>
                        <Col className={classes.modalListLineTitle}>Usuário</Col>
                        <Col className={classes.modalListLineTitle}>Tempo de conexão</Col>
                    </Row>
                    {
                        participacoesConsolidado.map((participacao) => {
                            const nome=getNomeParticipante(participacao);

                            return (
                                <Row key={_.uniqueId()} style={{paddingBottom: 5}}>
                                    <Col className={classes.modalListLineData}>{nome}</Col>
                                    <Col className={classes.modalListLineData}>{environment.formataQuantidadeSegundos(participacao.tempo_total_segundos)}</Col>
                                </Row>
                            );
                        })
                    }
                </Fragment> : null
                }

                <Row className={classes.modalListLine}>
                    <Button
                        variant="secondary"
                        className={`${classes.button} btn-secondary-get`}
                        onClick={() => this.setState({relatorioDetalhado: !this.state.relatorioDetalhado, relatorioDetalhadoOpcoes: {}})}
                    >
                        {this.state.relatorioDetalhado ? "Relatório simples" : "Relatório detalhado"}
                    </Button>
                </Row>

                {
                    this.state.relatorioDetalhado? this.renderRelatorioDetalhadoForm(primeiraEntradaISO, ultimaSaidaISO, sessao.id) : null
                }
            </Fragment>
        );
    }

    renderRelatorioDetalhadoForm (primeiraEntradaISO, ultimaSaidaISO, sessaoId) {
        const { classes, client } = this.props;
        let {intervalos, percentualPermanencia} = this.state.relatorioDetalhadoOpcoes;

        if(!intervalos)
            intervalos = [{inicio: primeiraEntradaISO, fim: ultimaSaidaISO}];

        if(percentualPermanencia === undefined)
            percentualPermanencia = 70;

        const adicionaIntervalo = () => {
            const novosIntervalos = [...intervalos, {inicio: primeiraEntradaISO, fim:ultimaSaidaISO}];
            this.setState({relatorioDetalhadoOpcoes: {
                ...this.state.relatorioDetalhadoOpcoes,
                    intervalos: novosIntervalos
            }});
        }

        const removeIntervalo = (chave) => {
            const novosIntervalos = [... intervalos.slice(0, chave), ...intervalos.slice(chave+1)];
            this.setState({relatorioDetalhadoOpcoes: {
                    ...this.state.relatorioDetalhadoOpcoes,
                    intervalos: novosIntervalos
                }});
        }

        const modificaCampoData = (index, campo, valor) => {
            if(valor == "Invalid Date") {
                return;
            }

            const novosIntervalos = [... intervalos.slice(0, index), {
                ...intervalos[index],
                [campo]: Environment.localDateAndTimeStringToIso(Environment.momentToLocalDateAndTimeString(valor)
                )
            }, ...intervalos.slice(index+1)];

            this.setState({relatorioDetalhadoOpcoes: {
                    ...this.state.relatorioDetalhadoOpcoes,
                    intervalos: novosIntervalos
            }});
        };

        return <Fragment>
            <MuiPickersUtilsProvider locale={brLocale} utils={DateFnsUtils}>
                <Row className="form-body-row">
                    <Col sm="12">
                        {/* Duração da reunião */}
                        <Group as={Row} style={{marginBottom: 0}}>
                            <Label column sm="4">Primeira conexão:</Label>
                            <Label column sm="8">{environment.momentToLocalDateAndTimeString(primeiraEntradaISO)}</Label>
                        </Group>
                        {/* Duração da reunião */}
                        <Group as={Row} style={{marginBottom: 0}}>
                            <Label column sm="4">Última desconexão:</Label>
                            <Label column sm="8">{environment.momentToLocalDateAndTimeString(ultimaSaidaISO)}</Label>
                        </Group>
                        {/* Permanência */}
                        <Group as={Row} style={{marginBottom: 0}}>
                            <Label column sm="4" htmlFor={"percentualPermanencia"}>Permanência % mínima:</Label>
                            <Col sm="1">
                                <Input id="percentualPermanencia" name="nome" type="text" onChange={(e)=>{this.setState({relatorioDetalhadoOpcoes: {
                                        ...this.state.relatorioDetalhadoOpcoes,
                                        percentualPermanencia: !e.target.value || (parseInt(e.target.value) != NaN && parseInt(e.target.value)>=0 && parseInt(e.target.value) <=100) ? (
                                            parseInt(e.target.value) ? parseInt(e.target.value) : ''
                                        ) : percentualPermanencia
                                    }})}} value={percentualPermanencia} />
                            </Col>
                            <Col sm="1">
                                %
                            </Col>
                        </Group>

                        {/* Períodos */}
                        <Group as={Row} style={{marginBottom: 0}}> {/*Repetir*/}
                            <Label column sm="4" htmlFor={"inicio"}>Períodos a serem considerados:</Label>
                        </Group>
                        {intervalos.map( (intervalo, chave) =>
                            <Group key={chave} as={Row} style={{marginBottom: 0}}> {/*Repetir*/}
                                <Col sm="3" >&nbsp;</Col>
                                <Col sm="9" >
                                    <Group style={{marginBottom: 0}} as={Row}>
                                        <Col sm="4">

                                            <KeyboardDateTimePicker
                                                margin = "normal"
                                                id = "inicio"
                                                labelFunc = {dt => Environment.momentToLocalDateAndTimeString(dt)}
                                                value = {intervalo.inicio}
                                                onChange = {(date, formattedDate) => {
                                                    if(formattedDate.indexOf('_') == -1)
                                                        modificaCampoData(chave, 'inicio', Environment.localDateAndTimeStringToMoment(formattedDate + ":00"));
                                                }}
                                                format = "dd/MM/yyyy hh:mm"
                                                label={"de"}
                                                disableFuture
                                                invalidDateMessage = "Data inválida."
                                                KeyboardButtonProps = {{
                                                    'aria-label': 'change date',
                                                }}
                                                minDate={primeiraEntradaISO}
                                                maxDate={ultimaSaidaISO}
                                                minDateMessage={"Data anterior à primeira conexão"}
                                                maxDateMessage={"Data posterior à última desconexão"}
                                            />

                                        </Col>
                                        <Col sm="4">
                                            <KeyboardDateTimePicker
                                                margin = "normal"
                                                id = "fim"
                                                labelFunc = {dt => Environment.momentToLocalDateAndTimeString(dt)}
                                                value = {intervalo.fim}
                                                onChange = {(date, formattedDate) => {
                                                    if(formattedDate.indexOf('_') == -1)
                                                        modificaCampoData(chave, 'fim', Environment.localDateAndTimeStringToMoment(formattedDate + ":00"));
                                                }}
                                                format = "dd/MM/yyyy hh:mm"
                                                label={"até"}
                                                disableFuture
                                                invalidDateMessage = "Data inválida."
                                                KeyboardButtonProps = {{
                                                    'aria-label': 'change date',
                                                }}
                                                minDate={intervalo.inicio}
                                                maxDate={ultimaSaidaISO}
                                                minDateMessage={"Data final deve ser menor que inicial"}
                                                maxDateMessage={"Data posterior à última desconexão"}
                                            />
                                        </Col>
                                        <Col sm="1">
                                            <Button style={{marginTop: 25}} type="button" onClick={ () => removeIntervalo(chave) }>-</Button>
                                        </Col>
                                    </Group>
                                </Col>
                            </Group>
                        )}

                        <Group as={Row}>
                            <Col sm="3" >&nbsp;</Col>
                            <Col sm="9" >
                                <Group as={Row}>
                                    <Col sm="8" >&nbsp;</Col>
                                    <Col sm="1" >
                                        <Button style={{marginTop: 5}} type="button" onClick={ () => adicionaIntervalo() }>+</Button>
                                    </Col>
                                </Group>
                            </Col>
                        </Group>


                    </Col>
                </Row>
                {this.state.submitting ? <div>
                    <Label>Gerando relatório...</Label>
                </div> : <Button
                    disabled={!(intervalos?.length > 0)}
                    variant="primary"
                    className={`${classes.button} btn-primary-get`}
                    style={{minWidth: 200}}
                    onClick={() => {
                        const jsonParamsRelatorio = JSON.stringify({percentualPermanencia, intervalos});
                        console.log('gerarRelatorio', {sessaoId, jsonParamsRelatorio});
                        this.setState({submitting: true});
                        client.query({
                            query: organizadorRelatorioParticipacaoQuery,
                            variables: {
                                sessao: sessaoId,
                                jsonParamsRelatorio: jsonParamsRelatorio
                            },
                            fetchPolicy: "network-only"
                        }).then(data => {
                            let csvContent = data?.data?.organizadorRelatorioParticipacao?.value;
                            const BOM = "\uFEFF";
                            csvContent = "data:text/csv;charset=UTF-8," + encodeURIComponent(BOM + csvContent ) ;
                            window.open(csvContent);
                            this.setState({submitting: false});
                        });
                    }}
                >
                    Gerar arquivo
                </Button>
                }
            </MuiPickersUtilsProvider>
        </Fragment>
            ;
    }

    geraActions(sessao) {
        const actions = [];

        actions.push({
            icon: AddBoxOutlinedIcon,
            tooltip: 'Criar vídeo a partir desta gravação',
            onClick: (event, rowData) => {
                const gravacao = {
                    'gravacao': rowData,
                    'parentSession': sessao
                }
                this.setState({
                    showModalNovoVideo: true,
                    gravacaoSelecionada: gravacao
                });
            }
        });

        actions.push({
            icon: VisibilityOutlinedIcon,
            tooltip: 'Ver',
            onClick: (event, rowData) => {
                window.open(rowData.url_ver);
            }
        });
        actions.push({
            icon: GetAppOutlinedIcon,
            tooltip: 'Download da gravação',
            onClick: (event, rowData) => {
                var anchor = document.createElement('a');
                anchor.href = rowData.url_baixar_video;
                anchor.download = rowData.url_baixar_video;
                document.body.appendChild(anchor);
                anchor.click();
            }
        });

        return actions;
    }

    renderTabGravacoes(sessao) {
        const { classes } = this.props;
        const actions = this.geraActions(sessao);

        const teveGravacao = sessao.participacoes.some( el => el.possui_evento_iniciar_gravacao );
        let bodyMessage = "";
        
        if (!teveGravacao) {
            bodyMessage = 'Nenhuma gravação para esta sessão';
        } else {
            if (sessao.gravacoes.length == 0) {
                bodyMessage = (
                    <div className={classes.spinnerWrapper}>
                        <span className={classes.spinnerText}>Em processamento</span>
                        <div className={classes.spinner}>
                            <CircularProgress />
                        </div>
                    </div>
                );
            }
        }

        this._gravacaoVideoQueryVariables = {
            'sessao_id': sessao.id
        };

        return (
            <Fragment>
                <div className={classes.gravacoesTableWrapper}>
                    <MaterialTable
                        actions={actions}
                        columns={[
                            { title: "Início", field: "inicio", render: rowData => Environment.momentToLocalDateAndTimeString(rowData.inicio) },
                            { title: "Fim", field: "fim", render: rowData => Environment.momentToLocalDateAndTimeString(rowData.fim) },
                            { title: "Criada em", field: "created_at", render: rowData => Environment.momentToLocalDateAndTimeString(rowData.created_at) },
                            { title: "Publicada", field: "publicada", render: (rowData) => {
                                return <ReactSwitch parentStateHandler={ checked => {
                                    this.handlePublicadaSwitchChange(rowData.id, checked)
                                }} checked={!!rowData.publicada} />;
                            }},
                        ]}
                        data={sessao.gravacoes}
                        localization={{
                            body: {
                                emptyDataSourceMessage: bodyMessage
                            },
                            header: {
                                actions: 'Ações'
                            },
                            toolbar: {
                                searchPlaceholder: 'Pesquisar',
                                searchTooltip: 'Pesquisar'
                            }
                        }}
                        options={{
                            actionsColumnIndex: -1,
                            paging: false,
                            draggable: false,
                            search: false
                        }}
                        title={
                            "Gravações"
                        }
                    />
                </div>

                {this.defineModalNovoVideo()}
                {this.defineModalVideoPlayer()}

                <Query query={gravacaoVideosQuery} variables={{...this._gravacaoVideoQueryVariables}} pollInterval={5000} fetchPolicy='network-only'>

                    {({ data, loading, error, refetch }) => {
                        if (loading) return 'Loading...';
                        if (error) return `Error! ${error.message}`;
                        this._queryVideosRefetch = refetch;

                        const { videosMaterialTableQueryFeretch } = this.state;
                        if (!videosMaterialTableQueryFeretch) {
                            setTimeout(() => {
                                this.setState({
                                    videosMaterialTableQueryFeretch: this._queryVideosRefetch
                                });
                            }, 200);
                        }

                        const gravacoesVideoActions = [
                            data => ({
                                icon: VisibilityOutlinedIcon,
                                hidden: !data.url_video,
                                tooltip: 'Ver',
                                onClick: (event, rowData) => {
                                    this.setState({
                                        displayModalVideoPlayer: true,
                                        modalVideoUrl: rowData.url_video
                                    });
                                }
                            }),
                            {
                                icon: GetAppOutlinedIcon,
                                tooltip: 'Download do vídeo',
                                onClick: (event, rowData) => {
                                    var anchor = document.createElement('a');
                                    anchor.href = rowData.url_video;
                                    anchor.download = rowData.url_video;
                                    document.body.appendChild(anchor);
                                    anchor.click();
                                }
                            },
                            data => ({
                                icon: DeleteOutlinedIcon,
                                hidden: !data.url_video,
                                tooltip: 'Excluir',
                                onClick: (event, rowData) => {

                                    Swal.fire({
                                        title: "Você está certo disso?",
                                        text: `O vídeo ${rowData.nome} será excluído permanentemente.`,
                                        icon: "warning",
                                        confirmButtonColor: "#ff0000",
                                        confirmButtonText: 'Excluir',
                                        showCancelButton: true,
                                        cancelButtonText: 'Cancelar',
                                    }).then( status => {

                                        // Por algum motivo, quando se clica no botao de cancelar a chave é "dismiss", mas quando clica no botão de confirmar a chave é "value"
                                        const keyName = Object.keys(status)[0];

                                        if (keyName == 'value' && status[keyName] ) {
                                            const { client } = this.props;
                                            client.mutate({
                                                mutation: gravacaoVideoExclusao,
                                                variables: { id: rowData.id },
                                            }).then( data => {
                                                Swal.fire({
                                                    title: "Vídeo excluído",
                                                    text: "Vídeo foi excluído com sucesso",
                                                    icon: "success",
                                                    confirmButtonColor: "#5d5d5d",
                                                    showCancelButton: false,
                                                });
                                                this._queryVideosRefetch();
                                            }).catch( ex => {
                                                const errorMessage = ex.graphQLErrors.map(e => e.debugMessage).join("\n");
                                                Swal.fire({
                                                    title: "Erro ao excluir vídeo",
                                                    text: errorMessage || "",
                                                    icon: "error",
                                                    confirmButtonColor: "#ff0000",
                                                    showCancelButton: false,
                                                });
                                            });
                                        }
                                    });

                                }
                            })
                        ];

                        const jsonPartesRender = (data) => {
                            if (!data.json_partes || data.json_partes == '[]') return 'Completo';

                            const trechos = JSON.parse(data.json_partes);
                            let tag = "";
                            trechos.forEach( el => {
                                tag = tag ? tag+', '+el.inicio+' até '+el.fim : el.inicio+' até '+el.fim;
                            });
                            return tag;
                        }

                        const renderColunaPublicado = (data) => {
                            if (!data.url_video) {
                                return 'Processando...';
                            } else {
                                return (
                                    <ReactSwitch parentStateHandler={ checked => {
                                        this.handleVideoPublicadoSwitchChange(data.id, checked)
                                    }} checked={!!data.publicado} />
                                );
                            }
                        }

                        return (
                            <div className={classes.gravacoesTableWrapper}>
                                <MaterialTable
                                    actions={gravacoesVideoActions}
                                    columns={[
                                        { title: "Nome", field: "nome" },
                                        { title: "Início", field: "inicio", render: rowData => Environment.momentToLocalDateAndTimeString(rowData.inicio) },
                                        { title: "Partes", field: "json_partes", render: rowData => jsonPartesRender(rowData) },
                                        { title: "Criada em", field: "created_at", render: rowData => Environment.momentToLocalDateAndTimeString(rowData.created_at) },
                                        { title: "Publicado", field: "publicado", render: rowData => renderColunaPublicado(rowData) },
                                    ]}
                                    data={data.gravacaoVideosList}
                                    localization={{
                                        body: {
                                            emptyDataSourceMessage: 'Nenhum vídeo encontrado'
                                        },
                                        header: {
                                            actions: 'Ações'
                                        },
                                        toolbar: {
                                            searchPlaceholder: 'Pesquisar',
                                            searchTooltip: 'Pesquisar'
                                        }
                                    }}
                                    options={{
                                        actionsColumnIndex: -1,
                                        paging: false,
                                        draggable: false,
                                        search: false
                                    }}
                                    title={
                                        "Videos"
                                    }
                                />
                            </div>
                        );
                    }}

                </Query>

            </Fragment>
        );
    }

    handleVideoPublicadoSwitchChange(id, checked) {
        const { client } = this.props;
        const publicado = checked ? 1 : 0;

        client.mutate({
            mutation: gravacaoVideoAlteraPublicado,
            variables: {
                id,
                publicado
            }
        }).then(data => {
            Swal.fire({
                title: "Vídeo alterado!",
                text: "Vídeo alterado com sucesso",
                icon: "success",
                confirmButtonColor: "#5d5d5d",
                showCancelButton: false,
            });
        }).catch(ex => {
            const errorMessage = ex.graphQLErrors.map(e => e.debugMessage).join("\n");
            Swal.fire({
                title: "Erro ao alterar vídeo",
                text: errorMessage || "",
                icon: "error",
                confirmButtonColor: "#ff0000",
                showCancelButton: false,
            });
        });
    }

    render() {
        const { classes, handleCloseFnc } = this.props;
        const { clickedTtabIndex, sessaoId } = this.state;

        this._queryVariables = {
            id: sessaoId
        };

        return (
            <Query query={organizadorSessoesEncerradasPopupInfoQuery} variables={{...this._queryVariables}} pollInterval={5000} fetchPolicy='network-only'>

                {({ data, loading, error, refetch }) => {
                    if (loading) return 'Loading...'
                    if (error) return `Error! ${error.message}`
                    this._queryRefetch = refetch;

                    let tabIndex = clickedTtabIndex;
                    const { sessaoOne } = data;

                    // console.log('DATA: ', sessaoOne);

                    // Essa condição previne que **caso as participaçoes para a sessao sejam removidas** o popup tente exibir uma tab que foi desmontada
                    if (sessaoOne.participacoes.length == 0 && this.state.tabIndex != 0) {
                        tabIndex = 0;
                    }

                    return (
                        <Paper className={classes.root}>
                            <AppBar position="static" color="default">
                                <Tabs
                                    value={tabIndex}
                                    onChange={this.handleChangeTab}
                                    indicatorColor="primary"
                                    textColor="primary"
                                    aria-label="aria-label value"
                                >
                                    <Tab label="Geral" />
                                    {sessaoOne.participacoes.length > 0 ? <Tab label="Relatório de Participação" /> : null}
                                    {sessaoOne.participacoes.length > 0 ? <Tab label="Gravações" /> : null}
                                </Tabs>
                            </AppBar>

                            <Paper elevation={3} className={classes.tabRoot}>
                                {tabIndex == 0 ? this.renderTabGeral(sessaoOne) : null}
                                {tabIndex == 1 ? this.renderTabRelatorioParticipacao(sessaoOne) : null}
                                {tabIndex == 2 ? this.renderTabGravacoes(sessaoOne) : null}
                            </Paper>

                            <div className={classes.botaoFecharWrapper}>
                                <Button variant="primary-get" type="submit" onClick={handleCloseFnc}>Fechar</Button>
                            </div>
                        </Paper>
                    );
                }}

            </Query>
        );
    }

    defineModalNovoVideo() {
        const { showModalNovoVideo, gravacaoSelecionada, videosMaterialTableQueryFeretch } = this.state;
        const { classes } = this.props;

        return (
            <Modal open={showModalNovoVideo} onClose={this.handleClose}>
                <div className={classes.modalWrapper}>
                    <GravacaoNovoVideoModal gravacaoData={gravacaoSelecionada} handleCloseFnc={this.handleCloseModalNovoVideo} atualizarTabelaVideosFnc={videosMaterialTableQueryFeretch} />
                </div>
            </Modal>
        );
    }

    defineModalVideoPlayer() {
        const { displayModalVideoPlayer, modalVideoUrl } = this.state;
        const { classes } = this.props;

        if (!modalVideoUrl) return null;

        return (
            <Modal open={displayModalVideoPlayer} onClose={this.handleCloseVideoPlayerModal}>
                <div className={classes.modalWrapper}>
                    <VideoPlayerPopup videoUrl={modalVideoUrl} handleCloseFnc={this.handleCloseVideoPlayerModal} />
                </div>
            </Modal>
        );
    }

    handleCloseVideoPlayerModal() {
        this.setState({
            displayModalVideoPlayer: false,
            modalVideoUrl: null
        });
    }

    handleCloseModalNovoVideo() {
        this.setState({
            showModalNovoVideo: false,
            gravacaoSelecionada: null
        });
    }

}

export default withApollo(withStyles(styles)(OrgEncerradasPopupDetalhes));